import { forwardRef } from 'react';
import { withStyles } from '../../../utils';
import styles from './SwitchIndicator.module.scss';

const cn = withStyles(styles);

type SwitchIndicatorProps = {
  checked?: boolean;
  className?: string;
  disabled?: boolean;
};

/**
 * Visual-only; has no interactivity on its own.
 * examples:
 * @example
 * Put an input[type="checkbox"] AFTER it if you want it to be a checkbox.
 * ```
 * <label>
 *  <SwitchIndicator checked={checked} />
 *  <input type="checkbox" onChange={toggleChecked} />
 * </label>
 * ```
 * @example
 * Wrap it in a button if you want it to be a button.
 * ```
 * <button onChange={toggleChecked}>
 *  <SwitchIndicator checked={checked} />
 * </button>
 * ```
 *
 * @example
 * It can just be a visual representation of some other thing being activated/etc
 * ```
 * <button onClick={toggleChecked}>Toggle It</button>
 * ...
 * <SwitchIndicator checked={checked} />
 * ```
 */
const SwitchIndicator = forwardRef<HTMLSpanElement, SwitchIndicatorProps>(({ checked = false, className, disabled = false }, ref) => {
  return <span ref={ref} className={cn('switchIndicator', checked && 'checked', disabled && 'disabled', className)} />;
});

export default SwitchIndicator;
